import { UtilityService } from '../../services/utility.service';
import { AuxiliaryEditModel } from './auxiliary-edit.model';

export class Auxiliary
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            this.setZoneNumberAndRuntime();

            this.StartTimeInMinuteOfDay = this['ExtendedInfo']['Schedule1StartTimeInMinuteOfDay'];
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }

    public Name: string;
    public Description: string;
    public number = 0;
    public AuxiliaryNumber = 0;
    public IsActive = false;
    public IsEnabled = false;
    public IsDisplayed = false;
    public ZoneNumber = 0;
    public RunTimeInMinutes = 0;
    public StartTimeInMinuteOfDay: number;
    public ActiveDays: number;

    static updateAuxiliaryWithAuxiliaryEditModel(auxiliary: Auxiliary, auxiliaryEdit: AuxiliaryEditModel)
    {
        auxiliary.Description = auxiliaryEdit.Name;
        auxiliary.IsEnabled = auxiliaryEdit.IsEnabled;
        auxiliary.ZoneNumber = auxiliaryEdit.ZoneForAuxiliary;
        auxiliary.RunTimeInMinutes = auxiliaryEdit.RunTimeInMinutes;
        auxiliary.StartTimeInMinuteOfDay = auxiliaryEdit.StartTimeInMinuteOfDay;
        auxiliary.ActiveDays = UtilityService.convertBooleanArrayToByte(auxiliaryEdit.ActiveDays);
    }

    private setZoneNumberAndRuntime()
    {
        const zoneIndex = this['ExtendedInfo']['StationRuntimes'].findIndex(runtime => runtime !== 0);
        this.ZoneNumber = zoneIndex + 1;
        this.RunTimeInMinutes = this['ExtendedInfo']['StationRuntimes'][zoneIndex] / 60;
    }
}
